import './Dashboard.css'

import React, { useEffect, useState } from 'react'
import PresentationCard from '../../../Components/PresentationCard';
import data from './Facultati.data.js'
function Facultati() {

    let [component, setComponent] = useState();
    useEffect(() => {
        setTimeout(() => setComponent(data.facultati.map(({title, image, dif, link, desc}, i) => (
            <PresentationCard title={title} image={image} dif={dif} link={link} desc={desc} />
         ))), 500)
    }, [])

    console.log(data.facultati)
    return (
        <>
            <div className="dashboard" >
                <div className='dashboard__cards'>
                {component}
                </div>
            </div>
        </>
    )
}

export default Facultati;
